// ABOUTME: Rich text section component for the news article builder.
// ABOUTME: Wraps ChatInput for full formatting support (size, weight, color, italic).

import { Box, IconButton } from "@mui/material";
import { useCallback, useRef } from "react";
import { useTranslation } from "react-i18next";

import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ChatInput from "../../../../theme/chat/ChatInput";

const ArticleTextSection = ({ content, onChange, onRemove, colors, theme }) => {
    const { t } = useTranslation();

    const onChangeRef = useRef(onChange);
    onChangeRef.current = onChange;

    const handleDataChange = useCallback((data) => {
        onChangeRef.current?.(data?.content);
    }, []);

    return (
        <Box
            sx={{
                position: "relative",
                "&:hover .section-actions": {
                    opacity: 1,
                },
            }}
        >
            {/* ChatInput as the editor */}
            <Box
                sx={{
                    background: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[100],
                    borderRadius: 4,
                    pt: 2,
                    px: 1.5,
                    pb: 1,
                    position: "relative",
                }}
            >
                {/* Delete button - top right */}
                <Box
                    className="section-actions"
                    sx={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                        opacity: 0,
                        transition: "opacity 150ms",
                        zIndex: 2,
                    }}
                >
                    <IconButton
                        size="small"
                        onClick={onRemove}
                        sx={{
                            width: 28,
                            height: 28,
                            color: colors.txt["secondary"],
                            "&:hover": { color: colors.red[400] },
                        }}
                    >
                        <DeleteOutlineIcon sx={{ fontSize: 16 }} />
                    </IconButton>
                </Box>
                <ChatInput
                    hideSend
                    hideAttachments
                    initialContent={content}
                    onDataChange={handleDataChange}
                    colors={colors}
                    theme={theme}
                    placeholder={t("write_something") || "Schrijf iets..."}
                />
            </Box>
        </Box>
    );
};

export default ArticleTextSection;
